module.exports = __webpack_public_path__ + "img/replacement.877748bf.svg";